<template>
  <div class="page">
    <div v-if="bannerImageUrl" class="pc-header-image">
      <img :src="bannerImageUrl" />
    </div>
    <div class="page-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page',
  props: {
    bannerImageUrl: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less">
.page {
  width: 100%;

  .pc-header-image {
    /* margin-left: calc((-100vw + 1440px) * 0.5); */
    width: 100%;
    min-width: var(--layout-min-width);
    aspect-ratio: 16/3;

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .page-content {
    max-width: var(--layout-max-width);
    min-width: var(--layout-min-width);
    margin: 0 auto;
    padding: 0;
  }
}


/* 小屏幕（移动端） */
@media screen and (max-width: 767px) {
  .page{
    .pc-header-image {
      min-width: auto;
      aspect-ratio: 375/114;
    }
    .page-content{
      min-width: auto;
      padding:0 1.333rem;
    }
  }
}
</style>